var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#272726",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.7 14.505-1.228-1.283a.87.87 0 0 0-1.268 0 .967.967 0 0 0 0 1.325l1.862 1.945a.87.87 0 0 0 1.268 0l4.46-4.66a.967.967 0 0 0 0-1.324.87.87 0 0 0-1.268 0L7.7 14.505z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.724 22.125H2.276V3.656h4.12V4.5c0 .518.402.938.897.938H10.7c.495 0 .897-.42.897-.938v-.844h4.127v18.469zM8.19 1.875h1.614v1.688H8.19V1.875zm8.43-.094h-5.023V.938C11.597.42 11.195 0 10.7 0H7.293c-.495 0-.896.42-.896.938v.843H1.379c-.495 0-.896.42-.896.938v20.343c0 .518.401.938.896.938h15.242c.495 0 .896-.42.896-.938V2.72c0-.518-.401-.938-.896-.938z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.ae67faccce03f23f1d59c96426c4cdb7.svg";
export { ForwardRef as ReactComponent };